/**
 * @file: 画布cube render 方法
 * @author: xiaolong.huang@dmall.com
 */

import Config from '../../config';
import * as SketchpadRenderCore from './renderCore/index';

export default function render(cube: CubeNode): boolean {
    SketchpadRenderCore.selectTabSwitch(cube);

    return true;
}
